import Swiper from 'swiper';
import {Grid, Navigation} from 'swiper/modules';

export function initBusinessTilesSlider() {
    for (let businessTileSlider of document.querySelectorAll('.businessTiles.swiperSingleRow.swiper')) {
        Swiper.use([Grid,Navigation]);
        const swiper = new Swiper(businessTileSlider, {
            slidesPerView: 2,
            grid: {
                rows: 1,
                fill: 'row'
            },
            spaceBetween: 35,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    grid: {
                        rows: 1,
                        fill: 'row'
                    },
                },
                1024: {
                    slidesPerView: 4,
                    grid: {
                        rows: 1,
                        fill: 'row'
                    },
                    spaceBetween: 64,
                }
            }
        });
    }

    for (let businessTileSlider of document.querySelectorAll('.businessTiles.swiperDualRow.swiper')) {
        Swiper.use([Grid,Navigation]);
        const swiper = new Swiper(businessTileSlider, {
            slidesPerView: 2,
            grid: {
                rows: 1,
                fill: 'row'
            },
            spaceBetween: 35,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    grid: {
                        rows: 2,
                        fill: 'row'
                    },
                },
                1024: {
                    slidesPerView: 4,
                    grid: {
                        rows: 2,
                        fill: 'row'
                    },
                    spaceBetween: 64,
                }
            }
        });
    }
}